<template>
  <div class="gerenciamento-usuario">
    <g-card class="card-gerenciamento-usuario"  :expansivel="true" :comecaFechado="false">
      <template #cabecalho>
        <div class="header-filtros">
          <div class="titulo-filtros-cabecalho"> Usuários </div>
          <div class="header-icons">
            <g-button
            class="trash-box"
            tipo="cinza" altura="35px"
            largura="45px"
            icone="icone_lixo.svg"
            tamanhoIcone="15px"
            somenteIcone
            :sombreado="false"
            v-tooltip="'Limpar filtro'"
            v-on:acao="limparFiltro"
            />

            <g-button
            class="plus-button"
            corIconeClass="#FFF"
            cor="#4F2C19"
            altura="35px"
            largura="45px"
            icone="pi pi-plus"
            tamanhoIcone="15px"
            somenteIcone
            :sombreado="false"
            @click="cadastrarUsuario"
            />

            <g-button
            class="buscar-button-header-filtro"
            largura="150px" icone="icone_lupa.svg"
            negritoTexto
            tamanhoIcone="15px"
            tamanhoTexto="14px"
            altura="35px"
            gap="10px"
            :sombreado="false"
            v-on:acao="buscarUsuarios"
            >
              BUSCAR
            </g-button>
          </div>
        </div>
      </template>
      
      <g-form>
        <div class="gerenciamento-usuario-conteudo espacamento-filtros">            
          <div class="filtro-nome-usuario">
            <div class="titulo-conteudo-filtros"> Usuário</div>
            <PInputText class="usuario-input input-label" placeholder="Insira o nome do usuário" v-model="nomeUsuario"/>
          </div>
          
          <div class="filtro-login-usuario">
            <div class="titulo-conteudo-filtros"> Login </div>
            <PInputText class="login-input input-label" placeholder="Insira o login do usuário" v-model="login" />
          </div>
        </div>
      </g-form>

      <div class="buscar-button-filtro">
        <g-button
        class="buscar-button"
        largura="300px"
        icone="icone_lupa.svg"
        negritoTexto
        tamanhoIcone="15px"
        tamanhoTexto="14px"
        altura="35px"
        gap="10px"
        :sombreado="false"
        v-on:acao="buscarUsuarios"
        >
          BUSCAR
        </g-button>
      </div>
    </g-card>
    
    <g-card v-if="mensagemvazio" paddingDefault="1em 0 3em" :temCabecalho="false">
      <img class="icone-global-imagemfundo" src="@/assets/imgs/Ilustracao_erro.svg" />
      <div class="texto-padrao-imagemfundo">
        Verifique os filtros e clique em buscar para exibir os resultados
      </div>
    </g-card>

    <g-card v-else-if="!mensagemvazio" paddingDefault="0em 0 3em" :temCabecalho="false">
      <g-data-table
      Titulo="Usuarios" 
      :colunas="Colunas" 
      :valores="UsuariosArray" 
      v-on:duploClickLinha="detalhesUsuario"
      :Excluivel= true 
      v-on:excluir="excluir"
      >
      </g-data-table>
    </g-card>

    <PDialog :showHeader="false" :closable="false" v-model:visible="popupExcluir">
      <div class="titulo-popup-finalizado popups-consultar-orcamentos"> Deseja mesmo excluir este usuário? </div>
      <div class="botoes-popup">
        <div>
          <g-button
          tipo="cinza"
          negritoTexto 
          largura="200px" 
          altura="35px" 
          @click="popupExcluir = false"
          >
            NÃO
          </g-button>
        </div>
        <div>
          <g-button
          negritoTexto
          largura="200px" 
          altura="35px" 
          @click="confirmacaoExcluir"
          >
            SIM
          </g-button>
        </div>
      </div>
    </PDialog>


    <PDialog :showHeader="false" :closable="false" v-model:visible="popupGrupoExistente">
      <div class="titulo-popup-finalizado popups-consultar-orcamentos"> Impossível Excluir! Esse usuário está vinculado a algum grupo.</div>
      <div class="botoes-popup">
        <div>
          <g-button
          tipo="cinza"
          negritoTexto 
          largura="200px" 
          altura="35px" 
          @click="popupGrupoExistente = false"
          >
            FECHAR
          </g-button>
        </div>
      </div>
    </PDialog>
  </div>
</template>

<script>
import GerenciamentoUsuarios from "./GerenciamentoUsuarios.js";
export default GerenciamentoUsuarios;
</script>

<style scoped>

@media (min-width:310px) {
    
}

@media (min-width:368px) {

}

@media (min-width:500px) {
.gerenciamento-usuario-conteudo {
  display: grid;
  grid-template-columns: repeat(2, minmax(4em, 18em));
  grid-template-rows: auto;
  grid-column-gap: 20px;
}
.filtro-nome-usuario { grid-area: 1 / 1 / 2 / 2; }
.filtro-login-usuario { grid-area: 1 / 2 / 2 / 3; }
}

@media (min-width:801px) {
.gerenciamento-usuario-conteudo {
  grid-template-columns: repeat(2, minmax(4em, 18em)) auto;
}
}

@media (min-width:1025px) { 

}

@media (min-width:1281px) { 
    
}

</style>
